import type { $Fetch } from 'ofetch';
import type { ParcelaArtifactGateway } from '@/application/port/out/ParcelaArtifactGateway';
import type { ParcelaPix, ParcelaBoleto } from '@/domain/model/ParcelaArtifact';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway de artefatos de cobrança por parcela (commerce).
 * Root `/api/v1/commerce/vendas/parcelas/{parcelaId}` (issue-pix / issue-boleto).
 *
 * @since G.5.23
 */
export class HttpParcelaArtifactGateway implements ParcelaArtifactGateway {
  private base(parcelaId: string): string {
    return `/api/v1/commerce/vendas/parcelas/${encodeURIComponent(parcelaId)}`;
  }
  constructor(private readonly client: $Fetch) {}

  async issuePix(parcelaId: string): Promise<ParcelaPix> {
    const res = await this.client<ApiResponse<ParcelaPix>>(`${this.base(parcelaId)}/issue-pix`, { method: 'POST' });
    assertApiSuccess(res);
    return res.data;
  }
  async issueBoleto(parcelaId: string): Promise<ParcelaBoleto> {
    const res = await this.client<ApiResponse<ParcelaBoleto>>(`${this.base(parcelaId)}/issue-boleto`, { method: 'POST' });
    assertApiSuccess(res);
    return res.data;
  }
}
